import { useApiModel } from '@hooks/use-api-model';
import type { IPwlLabWaitModel } from '@/types/history/pwl-lab-wait';

const PWL_LAB_WAIT_ENDPOINT = '/api/register/pwl-lab-wait';

const defaultPwlLabWaitModel: IPwlLabWaitModel = {
    languageData: {},
};

export const usePwlLabWait = (registrationId: number, editKey: string) =>
    useApiModel(`${PWL_LAB_WAIT_ENDPOINT}/${registrationId}/${editKey}`, defaultPwlLabWaitModel);
